module.exports = __webpack_public_path__ + "img/selected6-min.6ab6d9ee.png";